import { render, staticRenderFns } from "./EmployerCustomDocTypePasswordVerification.vue?vue&type=template&id=5c4f1d56&scoped=true"
import script from "./EmployerCustomDocTypePasswordVerification.vue?vue&type=script&lang=js"
export * from "./EmployerCustomDocTypePasswordVerification.vue?vue&type=script&lang=js"
import style0 from "./EmployerCustomDocTypePasswordVerification.vue?vue&type=style&index=0&id=5c4f1d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f1d56",
  null
  
)

export default component.exports